import fetcher from '@api/fetchers/simpleFetcher';
import reduxFreeFetcher from '@api/fetchers';
import { getHost, getCMSHost } from '@utils/api-helper/host';

const defaultHost = getHost();
const CMSHost = getCMSHost();

export const getPricingsEndpoint = (goalUID) =>
  `v3/subscriptions/?goal=${goalUID}&v=3&iconic=true&upgrade=true&iconic_pro=true`;

export const fetchPricings = (goalUID) =>
  fetcher(`${defaultHost}${getPricingsEndpoint(goalUID)}`, {
    useCamelCase: false
  });

export const getPurchaseDetailsEndpoint = (
  subscriptionUID,
  referralCode = ''
) =>
  `v3/subscriptions/purchase_details/?subscription_uid=${subscriptionUID}&referral_code=${referralCode}`;

export const fetchPurchaseDetails = (subscriptionUID) =>
  fetcher(`${defaultHost}${getPurchaseDetailsEndpoint(subscriptionUID)}`);

export const fetchBundleDetails = (goalUID) =>
  fetcher(`${defaultHost}v1/subscriptions/bundle/${goalUID}/details`);

export const fetchComboFeatures = (goalUIDs) => {
  const goal_uid_string = goalUIDs
    .map((goal) => `goalUID_in=${goal}&`)
    .join('');

  return fetcher(`${CMSHost}api/combo-goal-properties?${goal_uid_string}`);
};

export const fetchCheckoutStaticData = (goalUID) =>
  fetcher(`${CMSHost}checkout-static-data/${goalUID}`);

export const fetchSubscriptionFeatures = (goalUID) =>
  fetcher(`${CMSHost}subscription-features/${goalUID}`);

export const fetchSubscriptionHighlights = (goalUID) =>
  fetcher(`${CMSHost}subscription-highlights/${goalUID}`);

export const fetchSubscriptionFaqs = (key) =>
  fetcher(`${CMSHost}subscription-faqs/${key}`);

export const sendReferralEvent = (referralCode) =>
  reduxFreeFetcher('v1/subscriptions/referral_events/create', {
    requestType: 'POST',
    body: {
      referral_code: referralCode
    }
  });
